import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Image } from "./files/Image";
export class ProductPrices extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.unitPrice = 0;
        this.warranty = 0;
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], ProductPrices.prototype, "unitPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ProductPrices.prototype, "warranty", void 0);
export var ProductType;
(function (ProductType) {
    ProductType["Cup"] = "Cup";
    ProductType["Other"] = "Other";
})(ProductType || (ProductType = {}));
export class Product extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        /**
         * Set this if you need to group the product amount by a specific group amount
         */
        this.soldPer = 1;
        /**
         * This field will get overwrittend depending on the authenticated user
         */
        this.prices = ProductPrices.create({});
        this.type = ProductType.Cup;
        this.description = "";
        this.images = [];
    }
    apply(priceList) {
        const prices = priceList.get(this.id);
        if (prices) {
            // Restrict minimum
            if (this.prices.unitPrice < prices.unitPrice) {
                prices.unitPrice = this.prices.unitPrice;
            }
            if (this.prices.warranty < prices.warranty) {
                prices.warranty = this.prices.warranty;
            }
        }
        return this.patch({
            prices
        });
    }
    get amountSuffixSingular() {
        switch (this.type) {
            case ProductType.Cup: return "beker";
            case ProductType.Other: return "stuk";
        }
    }
    get amountSuffix() {
        switch (this.type) {
            case ProductType.Cup: return "bekers";
            case ProductType.Other: return "stuks";
        }
    }
    /// In gram
    get savedPlasticWeight() {
        switch (this.type) {
            case ProductType.Cup: return 6;
            case ProductType.Other: return 0;
        }
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Product.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Product.prototype, "name", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Product.prototype, "soldPer", void 0);
__decorate([
    field({ decoder: ProductPrices })
], Product.prototype, "prices", void 0);
__decorate([
    field({ decoder: new EnumDecoder(ProductType) })
], Product.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Product.prototype, "description", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Image) })
], Product.prototype, "images", void 0);
//# sourceMappingURL=Product.js.map